export default __webpack_public_path__ + "media/images/icons/burger-4eadf2a5356e6ee9a6fb3b51d0c9a0fe.svg";